module.exports = __webpack_public_path__ + "static/img/three.806bfda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newNmg/three.png
// module id = jKy5
// module chunks = 1